import { Grid, Typography } from "@mui/material";
import ControlledSSCreatable from "components/Controller/ControlledSSCreatable";
import ControlledTextField from "components/Controller/ControlledTextField";
import { CustomizedBox } from "components/Custom/CustomizedBox";
import { useDisable } from "hooks/use-disable";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { IDeliveryTrip } from "types/Logistic/deliveryTrip";

// Frozen toggle + item-code swap (SP00001 ↔ SP00002) retired per 86d37db3t.
// Temperature no longer influences pricing — the item code is always SP00001
// and the temperature category is captured on `temperature_type` (Creatable).
const DeliveryInfo = () => {
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext<IDeliveryTrip>();
  const { t } = useTranslation();
  const [disabled] = useDisable();

  return (
    <CustomizedBox margin={0}>
      <Typography fontWeight={600} mb={1}>
        {t("logistic.delivery_trip.delivery_info")}
      </Typography>
      <Grid container spacing={1.5}>
        <Grid item xs={12} sm={12} md={4}>
          <ControlledTextField
            control={control}
            name="item_type"
            label={t("logistic.delivery_trip.item_type")}
            error={Boolean(errors.item_type)}
            helperText={errors.item_type?.message}
            viewMode={disabled}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <ControlledTextField
            control={control}
            name="item_amount"
            label={t("logistic.delivery_trip.item_amount")}
            error={Boolean(errors.item_amount)}
            helperText={errors.item_amount?.message}
            viewMode={disabled}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <ControlledSSCreatable
            control={control}
            name="temperature_type"
            dataName="temperature_type"
            documentType="delivery_trip"
            setValue={setValue}
            defaultOptions={[]}
            label={t("logistic.delivery_trip.temperature_type")}
            error={Boolean(errors.temperature_type)}
            helperText={errors?.temperature_type?.message?.toString()}
            viewMode={disabled}
            required
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <ControlledTextField
            control={control}
            name="packaging_location"
            label={t("logistic.delivery_trip.packaging_location")}
            error={Boolean(errors.packaging_location)}
            helperText={errors.packaging_location?.message}
            viewMode={disabled}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <ControlledTextField
            control={control}
            name="expected_temperature"
            label={t("logistic.delivery_trip.expected_temperature")}
            error={Boolean(errors.expected_temperature)}
            helperText={errors.expected_temperature?.message}
            viewMode={disabled}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <ControlledSSCreatable
            control={control}
            name="container_type"
            setValue={setValue}
            defaultOptions={[]}
            documentType="delivery_trip"
            label={t("logistic.delivery_trip.container_type")}
            error={Boolean(errors.container_type)}
            helperText={errors?.container_type?.message}
            viewMode={disabled}
          />
        </Grid>
      </Grid>
    </CustomizedBox>
  );
};

export default DeliveryInfo;
